export default "__VITE_ASSET__39d4da5f__"